// reference: https://github.com/Uniswap/v4-periphery/blob/main/src/libraries/PositionInfoLibrary.sol

export class PositionInfoLibrary {
  private readonly TICK_LOWER_OFFSET = 8;

  private readonly TICK_UPPER_OFFSET = 32;

  // The PositionInfo value (uint256 in Solidity, represented as bigint in TypeScript)
  private positionInfo: bigint;

  // Constructor to initialize the positionInfo
  constructor(positionInfo: bigint) {
    this.positionInfo = positionInfo;
  }

  // Helper function to perform shift right
  private static shr(shift: number, value: bigint): bigint {
    return value >> BigInt(shift);
  }

  // Helper function to sign-extend for int24
  private static signextend(byteSize: number, value: bigint): bigint {
    const bitLength = (byteSize + 1) * 8; // Convert byte size to bit size
    const mask = BigInt(1) << BigInt(bitLength - 1);
    const extendedValue = value & ((BigInt(1) << BigInt(bitLength)) - BigInt(1)); // Keep only the required bits
    return (extendedValue ^ mask) - mask; // Sign-extend the value
  }

  /**
   * Gets the lower tick from PositionInfo (uint256).
   * @returns The tickLower as an int24 (number in TypeScript).
   */
  public getTickLower(): number {
    const shiftedValue = PositionInfoLibrary.shr(this.TICK_LOWER_OFFSET, this.positionInfo);
    const tickLower = PositionInfoLibrary.signextend(2, shiftedValue);
    return Number(tickLower); // Convert bigint to number (int24 equivalent)
  }

  /**
   * Gets the upper tick from PositionInfo (uint256).
   * @returns The tickUpper as an int24 (number in TypeScript).
   */
  public getTickUpper(): number {
    const shiftedValue = PositionInfoLibrary.shr(this.TICK_UPPER_OFFSET, this.positionInfo);
    const tickUpper = PositionInfoLibrary.signextend(2, shiftedValue);
    return Number(tickUpper); // Convert bigint to number (int24 equivalent)
  }
}
